<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text">
          {{ $t("fchart.chart_light") }}
          <v-btn class="ml-15" large color="accent" @click="newItem">
            {{ $t("crud.add") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            v-bind:label="$t('crud.search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="statements"
        :search="search"
        :loading="loading"
        v-bind:loading-text="$t('crud.loading')"
        :footer-props="{ itemsPerPageText: $t('crud.nr') }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click="viewItem(item.id)"
                class="mr-2 accent--text"
                v-bind="attrs"
                v-on="on"
              >
                mdi-magnify
              </v-icon>
            </template>
            <span class="text-uppercase"> {{ $t("crud.view") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2 secondary--text"
                @click="editItem(item.id)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span class="text-uppercase"> {{ $t("crud.edit") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2 info--text"
                @click="goMember(item.id)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-account-group
              </v-icon>
            </template>
            <span class="text-uppercase"> {{ $t("fchart.member") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2 success--text"
                @click="goProgress(item.id)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-progress-wrench
              </v-icon>
            </template>
            <span class="text-uppercase"> {{ $t("fchart.progress") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2 yel--text"
                @click="goMail(item.id)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-email
              </v-icon>
            </template>
            <span class="text-uppercase">email</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="mr-2 warning--text"
                @click="goDef(item.id)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-chart
              </v-icon>
            </template>
            <span class="text-uppercase"> {{ $t("fchart.report") }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click="showDeleteDialog(item)"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span class="text-uppercase"> {{ $t("crud.delete") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <FlashMessage :error="error" v-if="error" key="error" />
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title>{{ $t("crud.delete") }}</v-card-title>
          <v-card-text
          >{{ $t("crud.select") }}: `{{ itemToDelete.family_name }}` <br />
            <br />{{ $t("crud.rys") }} <br />
            {{ $t("crud.irr") }}
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="dialogDelete = false"
            >{{ $t("crud.close") }}
            </v-btn>
            <v-btn color="primary" text @click="deleteItem()"
            >{{ $t("crud.delete") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getError } from "@/utils/helpers";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import FlashMessage from "@/components/input/FlashMessage";
import LchartService from "@/services/lchart/LchartService";

export default {
  name: "Users",
  components: { FlashMessage, ToolbarAuth, Navigation },
  data() {
    return {
      error: null,
      dialogDelete: false,
      itemToDelete: {},
      email: "",
      search: "",
      headers: [
        {
          text: this.$t("fchart.name"),
          align: "start",
          sortable: true,
          value: "family_name",
        },
        {
          text: this.$t("users.place"),
          align: "start",
          sortable: true,
          value: "place",
        },
        {
          text: this.$t("users.RelMan"),
          align: "start",
          sortable: true,
          value: "user.name",
        },
        { text: this.$t("crud.actions"), value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    showDeleteDialog(item) {
      this.itemToDelete = item;
      this.dialogDelete = !this.dialogDelete;
    },

    viewItem(id) {
      this.$router.push({ name: "lchartView", params: { id: id } });
    },
    editItem(id) {
      this.$router.push({ name: "lchartEdit", params: { id: id } });
    },
    goMember(id) {
      this.$router.push({ name: "lchartMemberIndex", params: { famId: id } });
    },
    goMail(id) {
      this.$router.push({ name: "lchartInvitation", params: { famId: id } });
    },
    goProgress(id) {
      this.$router.push({ name: "lchartStatus", params: { famId: id } });
    },
    goDef(id) {
      this.$router.push({ name: "lchartDef", params: { famId: id } });
    },
    deleteItem() {
      console.log("deleteItem", this.itemToDelete);
      let id = this.itemToDelete.id;
      this.error = null;
      LchartService.deleteMain(id)
        .then(() => {
          this.$store.dispatch("lchart/getMains");
          this.dialog = false;
        })
        .catch((error) => (this.error = getError(error)));

      this.dialogDelete = false;
    },
    newItem() {
      this.$router.push({ name: "lchartCreate" });
    },
  },
  computed: {
    ...mapGetters("lchart", ["loading", "statements"]),
  },
  created() {
    this.$store.dispatch("lchart/getMains");
  },
};
</script>

<style scoped></style>
